export const noticeList = [
    {
        nStatus: 'Disable',
        nID: '1',
        message: 'नेपाल सम्वत ११४३ तछलाथ्व (जेष्ठ ६ गते शनिबार ) हलिं नेवाः गुथि संस्कृति कव कजि कृष्ण प्रशाद प्रजापतिया सभा नाय् सुई जुईत्यंगु ZOOM ज्याझ्वः कीपुया प्यङगथाःमय याक मीसा व ह्यामु ख्वापाः करुणामयया प्रतिमूर्ति द्यो सुखी गछें समाज पाखें पलिस्था जुगु न्यालाः व न्हयेःन्हु खुनु दलबल सहित व पुलिस प्रशासन वया द्यो लीकानाः यंका कीपु नगरपालिकाया बन्द कोठाय् तयगु ज्या जुल व बिचे बिभिन्न थासय थो द्योया खयः सवाल जवाफ अन्तरक्रिया ज्याझ्वः जु जु अचानक द्यो ४ गते चान्ह्ये १२ ताःईले कीपूपिने यनिगु ज्याः जुईधुकल थो कीपूया छगु अत्यन्त बिबादित व महत्वपूर्ण खः जुगुलीं सांस्कृतिक स्वायत्त क्षेत्र कवया कजि श्रीकृष्ण महर्जन व कीपू गछें कचाया दुजः बुद्दिलाल महर्जन पाखें प्रमुख प्रस्तुत यानादिगुलिं हलिं नेवाः गुथिया दुजः व गुथियात माया यानादिपीं छिकपी सकलें पायछी ईःलय झाया खः न्यना वयक पिन्तः मागु सल्लाह सुझाव विया दितः ईनाप याना च्वनाः ।',
        detail1: 'ज्याझ्वः',
        detail2: 'जेष्ठ ६ गते शनिबार',
        detail3: 'बहनी ८:०० ताःईले',
        detail4: '',
        detail5: '',
        detail6: '',
        detail7: '',
        detail8: '',
        detail9: '',
        detail10: '',
    },
    {
        nStatus: 'Disable',
        nID: '2',
        message: 'हलिं नेवाः गुथिया  झिंन्पेक्वगु (१४) तःमुज्या लीपाया न्हापांगु परिषद मुनाज्याः थोहे वईगु नेपाल सम्वत ११४३ तछला थ्व सप्तमी जेष्ठ १३ गते शनिबार "सिभिल होम्स तिनथाना कचा" या ग्वसाले चन्द्रागिरि नगरपालिका वडा नम्बर १५ सिभिल होम्स हाउजिङ्ग  फेज २ तिनथाना क्लब हाउसें न्हीनेसिया १:०० ताःईले जुईत्यंगु ज्याझ्वःले संरक्षकजु, मुः ज्यासना पुचःया पदाधिकारीजु, दक्व कचाया कचा नाय् व कचाया केन्द्रीय प्रतिनिधिपीं, कव कजिपीं सचिवालय पदाधिकारीपीं सकले पायछी ईःलय झाया ज्याझ्वः झःझधायका बिइ धका जी मुः छ्यान्जे व कचाया केन्द्रीय प्रतिनिधि अमर काजि श्रेष्ठ छिकपीं नापं ईनाप यासें ईःलय झायादिंत ब्वनाःच्वनाः ।',
        detail1: 'ज्याझ्वःया मुःखः',
        detail2: '१. प्रतिबेदन प्रस्तुत व अनुमोदन',
        detail3: 'क) दक्व कव कजि या प्रतिबेदन',
        detail4: 'ख) दॉभरी या प्रतिबेदन',
        detail5: 'ग) मू छ्यान्जे या प्रतिबेदन',
        detail6: '२. बिधान शंशोधन प्रस्ताव',
        detail7: '३. कचा कचाया व कव या ज्याकुथिया साईनबोर्ड तयगु ।',
        detail8: '४. नेवा पाहॉ छें या अवधारणा',
        detail9: '५. थि थि ।',
        detail10: ''
    },
];
